var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLifeStoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 491.92 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m286.12 311.18a115.43 115.43 0 1 1 115.43-115.43 115.56 115.56 0 0 1 -115.43 115.43zm0-210.85a95.43 95.43 0 1 0 95.43 95.42 95.54 95.54 0 0 0 -95.43-95.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.12 253.77a10 10 0 0 1 -7.07-2.93l-46.76-46.78a38.85 38.85 0 0 1 53.84-56 38.86 38.86 0 0 1 53.87 1.05 38.91 38.91 0 0 1 0 54.94l-46.78 46.78a10 10 0 0 1 -7.1 2.94zm-26.37-96a18.85 18.85 0 0 0 -13.33 32.18l39.7 39.71 39.71-39.71a18.86 18.86 0 0 0 -26.67-26.66l-6 6a10 10 0 0 1 -14.15 0l-6-6a18.71 18.71 0 0 0 -13.26-5.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.92 512h-331.59a40 40 0 0 1 -40-40v-432a40 40 0 0 1 40-40h331.59a40 40 0 0 1 40 40v432a40 40 0 0 1 -40 40zm-331.59-492a20 20 0 0 0 -20 20v432a20 20 0 0 0 20 20h331.59a20 20 0 0 0 20-20v-432a20 20 0 0 0 -20-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.75 431.67h-311.26a10 10 0 0 1 -10-10v-371.51a10 10 0 0 1 10-10h311.26a10 10 0 0 1 10 10v371.51a10 10 0 0 1 -10 10zm-301.26-20h291.26v-351.51h-291.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.26 471.84h-80.32a10 10 0 0 1 0-20h80.32a10 10 0 0 1 0 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.08 484.92a10 10 0 0 1 -8.32-4.46 129.1 129.1 0 0 1 -21.76-71.87v-351.43a30.08 30.08 0 0 1 60.16 0v351.43a129.1 129.1 0 0 1 -21.76 71.87 10 10 0 0 1 -8.32 4.46zm0-437.84a10.09 10.09 0 0 0 -10.08 10.08v351.43a109.17 109.17 0 0 0 10.08 45.93 109.17 109.17 0 0 0 10.08-45.93v-351.43a10.09 10.09 0 0 0 -10.08-10.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.16 117.37h-40.16a10 10 0 0 1 0-20h40.16a10 10 0 0 1 0 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.59 351.35h-230.94a10 10 0 1 1 0-20h230.94a10 10 0 1 1 0 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.59 391.51h-230.94a10 10 0 1 1 0-20h230.94a10 10 0 0 1 0 20z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeStoryIcon);
export default __webpack_public_path__ + "static/media/lifeStoryIcon.da244b3a9be045fb90250b0a2dd67705.svg";
export { ForwardRef as ReactComponent };